module.exports = __webpack_public_path__ + "static/media/header-bg-hero.656d635b.png";